module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-250-Classes-Inactive-002b0deecd4f586e72a9b47de9462dc8.png";